

























import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'feedback',
})
export default class Feedback extends Vue {}
